import { Six_To_12_Options } from './../../shared/constants/mad-libs/dimension1-options/6-to-12-options.constant';
import { Six_to_8_Options } from './../../shared/constants/mad-libs/dimension1-options/6-to-8-options.constant';
import { Nine_To_12_Options } from './../../shared/constants/mad-libs/dimension1-options/9-to-12-options.constant';
import { K_to_5_Options } from './../../shared/constants/mad-libs/dimension1-options/k-to-5-options.constant';
import { K_To_8_Options } from './../../shared/constants/mad-libs/dimension1-options/k-to-8-options.constant';

export const DIMENSION_1 = {
  // Filter dimension
  madLib: 'Dimension1',
  options: {
    'K to 5': K_to_5_Options,
    'K to 8': K_To_8_Options,
    '6 to 8': Six_to_8_Options,
    '6 to 12': Six_To_12_Options,
    'Large HS': Nine_To_12_Options,
    'Small HS': Nine_To_12_Options,
    Charter: Nine_To_12_Options,
    Transfer: Nine_To_12_Options,
  },
  helperText: 'grouped by',
};

const ES_MS_GROUPING_OPTIONS = [
  {
    human: 'Grade',
    key: 'GRADE',
    columns: {},
  },
  {
    human: 'Point Person',
    key: 'POINT_PERSON',
    columns: {},
  },
];

const HS_GROUPING_OPTIONS = [
  {
    human: 'Class',
    key: 'CLASS_OF',
    columns: {},
  },
  {
    human: 'Grade',
    key: 'GRADE',
    columns: {},
  },
  {
    dimension: 'grouping',
    human: 'Grad Plan',
    key: 'GRAD_PLAN',
    columns: {},
  },
  {
    human: 'Point Person',
    key: 'POINT_PERSON',
    columns: {},
  },
];

const FAILURE_WITH_NO_SUPPORT_OPTIONS = [
  {
    human: 'Subject',
    key: 'SUBJECT',
    columns: {}, // tbd
  },
  {
    human: 'Course',
    key: 'COURSE',
    columns: {}, // tbd
  },
  {
    human: 'Teacher',
    key: 'TEACHER',
    columns: {},
  },
];

export const MID_LEVEL_GROUPINGS = {
  madLib: 'Groupings',
  options: {
    'K to 5': {
      POST_SECONDARY_FLAGS: ES_MS_GROUPING_OPTIONS,
      POST_SECONDARY_PLANS: ES_MS_GROUPING_OPTIONS,
      FAILURES_WITH_NO_SUPPORT: FAILURE_WITH_NO_SUPPORT_OPTIONS,
    },
    'K to 8': {
      POST_SECONDARY_FLAGS: ES_MS_GROUPING_OPTIONS,
      POST_SECONDARY_PLANS: ES_MS_GROUPING_OPTIONS,
      FAILURES_WITH_NO_SUPPORT: FAILURE_WITH_NO_SUPPORT_OPTIONS,
    },
    '6 to 8': {
      POST_SECONDARY_FLAGS: ES_MS_GROUPING_OPTIONS,
      POST_SECONDARY_PLANS: ES_MS_GROUPING_OPTIONS,
      FAILURES_WITH_NO_SUPPORT: FAILURE_WITH_NO_SUPPORT_OPTIONS,
    },
    '6 to 12': {
      POST_SECONDARY_FLAGS: HS_GROUPING_OPTIONS,
      POST_SECONDARY_PLANS: HS_GROUPING_OPTIONS,
      FAILURES_WITH_NO_SUPPORT: FAILURE_WITH_NO_SUPPORT_OPTIONS,
    },
    'Large HS': {
      POST_SECONDARY_FLAGS: HS_GROUPING_OPTIONS,
      POST_SECONDARY_PLANS: HS_GROUPING_OPTIONS,
      FAILURES_WITH_NO_SUPPORT: FAILURE_WITH_NO_SUPPORT_OPTIONS,
    },
    'Small HS': {
      POST_SECONDARY_FLAGS: HS_GROUPING_OPTIONS,
      POST_SECONDARY_PLANS: HS_GROUPING_OPTIONS,
      FAILURES_WITH_NO_SUPPORT: FAILURE_WITH_NO_SUPPORT_OPTIONS,
    },
    Charter: {
      POST_SECONDARY_FLAGS: HS_GROUPING_OPTIONS,
      POST_SECONDARY_PLANS: HS_GROUPING_OPTIONS,
      FAILURES_WITH_NO_SUPPORT: FAILURE_WITH_NO_SUPPORT_OPTIONS,
    },
    Transfer: {
      POST_SECONDARY_FLAGS: HS_GROUPING_OPTIONS,
      POST_SECONDARY_PLANS: HS_GROUPING_OPTIONS,
      FAILURES_WITH_NO_SUPPORT: FAILURE_WITH_NO_SUPPORT_OPTIONS,
    },
  },
};
